import { ReturnPolicySummarySchema } from "@redotech/redo-return-core-common/return-policy/summary";
import { returnPolicyIdFormat } from "@redotech/redo-return-id";
import * as z from "zod";

const ReturnPolicyListItemSchema = z.object({
  id: returnPolicyIdFormat.schema,
  name: z.string(),
  updatedAt: z.date(),
});

/** The team's live return policy with a summary, and its draft return policies. */
export const getReturnPolicies = {
  name: "getReturnPolicies" as const,
  input: z.null(),
  output: z.object({
    current: ReturnPolicyListItemSchema.extend({
      summary: ReturnPolicySummarySchema,
    }).nullable(),
    drafts: z.array(ReturnPolicyListItemSchema),
  }),
};
